// algoliaConfig.tsx
import algoliasearch, { SearchClient } from 'algoliasearch/lite';

const searchClient: SearchClient = algoliasearch('ZGG3XR6N96', 'cd4d6f86f5b208b5a7ee417d61df8a7f');

// Configuración de atributos a mostrar en los resultados
searchClient.addAlgoliaAgent('instantsearch.js', '6.40.4');

export default searchClient;
